import type { JSX } from 'react'

import { useTranslation } from 'react-i18next'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout } from '~/widgets/auth'
import { FinalMessage } from '../../shared/ui'

export function Title(): JSX.Element {
  return <AppTitle t={['forgot_password', 'success']} />
}

DonePage.displayName = 'DonePage'
export function DonePage(): JSX.Element {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <FinalMessage
        title={t('success')}
        body={t('password_changed_success')}
        button={t('sign_in')}
        to='/sign-in'
      />
    </AuthLayout>
  )
}
